"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAvailableSupply = void 0;
var getArticlesMinStock_1 = require("../../../../utils/generateSuppliesData/getArticlesMinStock");
function getAvailableSupply(_a, article, suppliesPerDate) {
    var product = _a.productObj;
    var articlesMinStock = getArticlesMinStock_1.getArticlesMinStock(suppliesPerDate);
    if (article === "total") {
        var quantityToReturn_1 = 0;
        suppliesPerDate.forEach(function (_a) {
            var _b, _c;
            var ARKTCOMART = _a.ARKTCOMART;
            var minStock = articlesMinStock[ARKTCOMART] || 0;
            if ((_b = product.articles) === null || _b === void 0 ? void 0 : _b.length) {
                var webSecurityStock = ((_c = product.articles.find(function (_a) {
                    var _ARKTCOMART = _a.ARKTCOMART;
                    return ARKTCOMART === _ARKTCOMART;
                })) === null || _c === void 0 ? void 0 : _c.webSecurityStock) || 0;
                quantityToReturn_1 +=
                    minStock - webSecurityStock > 0 ? minStock - webSecurityStock : 0;
            }
            else {
                var webSecurityStock = product.webSecurityStock || 0;
                quantityToReturn_1 +=
                    minStock - webSecurityStock > 0 ? minStock - webSecurityStock : 0;
            }
        });
        return quantityToReturn_1;
    }
    else {
        var minStock = articlesMinStock[article.ARKTCOMART] || 0;
        var webSecurityStock = article.webSecurityStock || 0;
        return minStock - webSecurityStock > 0 ? minStock - webSecurityStock : 0;
    }
}
exports.getAvailableSupply = getAvailableSupply;
